import {
  BONUS_PAGE,
  BONUS_HISTORY,
  COMMON_ERROR,
  NO_MATCH,
} from './routeTemplates';

export const EXCLUDED_ROUTES_FOR_SEO_TEXT = [
  // Bonuses
  BONUS_PAGE,
  BONUS_HISTORY,
  // Errors
  COMMON_ERROR,
  NO_MATCH,
];

export const EXCLUDED_ROUTES_FOR_META_TAGS = [];

export const EXCLUDED_ROUTES_FOR_FAQ = [];
